export const TEMPLATE_SHARE = 'template_share';
